<template>
	<div class="meeting-details">
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item v-for="(item,key,index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
					  <img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div class="buttons" 
		style="paddingBottom:120px;
		backgroundImage:url('//cdn.edstatic.com/203012120000/cd4b143a5ee2d1860000709e9a04d4c2/2024/02/7e8d8268-9edc-40a5-a769-6f3b25ef038e.png');backgroundSize:100% 100%;">
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/6ee22b255c12266d1c98529eebc0ff0a/2024/02/c23a8382-cb10-4e9e-8b8e-83c32885ad84.png" @click="skip(1675)"/>
            </div>
            <div class="one">
                <img src="//cdn.edstatic.com/203012120000/55a30bf3e1d649990e7d45ef6f6d8c54/2024/02/de30929d-ba98-4dc3-a203-dd488a9881c9.png" @click="skip(1678)"/>
            </div>
            <div class="one">
                <img src="//cdn.edstatic.com/203012120000/0dfdce4b801f049f6e853d94cc07025e/2024/02/cd26b836-56eb-4926-beb0-3de012f0ea30.png" @click="skip(1687)"/>
            </div>
            <div class="one" style="width:66%">
                <img src="//cdn.edstatic.com/203012120000/277e0c258d6961574450f251101b6e68/2024/02/506969c0-75e0-4e45-bc24-3efc9a6ad437.png" @click="skip(1677)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/4d312d41969a0b76b3f1ac39dd7bef1c/2024/02/36643cf2-8221-417d-b30b-eba0d8228214.jpg" @click="skip(1688)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/73c03442ce69bacd6138e811cc567952/2024/02/4b3cd1f1-6811-4dd5-994d-c8a29b7e8809.jpg" @click="skip(1676)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/c095b0430b7f52d1ca42095266debece/2024/02/88dfa339-5ccd-459c-964c-74fac6157df0.png" @click="skip(1679)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/d5099115bd11520006c1f7100f94b522/2024/02/6df505fc-e9dd-4662-b579-007a032efbdd.png" @click="skip(1689)"/>
            </div>
            <div class="one">
                <img src="//cdn.edstatic.com/203012120000/2d1469c99bfabb86261c794da943789c/2024/02/31efc4c3-5b58-43f6-99c5-e5a0cae28635.png" @click="skip(1680)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/e8707c3ad460a17ad76bcb0c0277cdd5/2024/02/2a44002a-b3ea-4538-b4af-c76c8f938ea6.png" @click="skip(1690)"/>
            </div>
			<div class="one">
                <img src="//cdn.edstatic.com/203012120000/071b946773629f41b12104f1b50b16e7/2024/02/6d56a17f-fed9-4b57-aa82-2785cd5f78ff.jpg" @click="skip(1691)"/>
            </div>
        </div>
	</div>
</template>
<script>
	// import Register from "../../components/Users/Register.vue"
	import {MeetingButtons,MeetingsCarousel,MeetingsDetails} from '../../config/interface.js'
	export default{
		data(){
			return{
				meetingButton:{},    //会议按钮
                swiperImg:[],
                meeting_id:'472'
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
               
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.getMeetingButtons(this.meeting_id);
			this.getMeetingCarousel();
            this.getMeetingDetails();
		},
		methods:{
			//会议轮播
			getMeetingCarousel(){
				const url=MeetingsCarousel;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
			clickSwiperImg(item){
				window.location.href=item.link;
			},
			//会议按钮
			getMeetingButtons(id){
				const url=MeetingButtons;
				const method='POST';
				let params={
					meeting_id:id
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						for(let i in data){
							this.meetingButton[data[i].id]=data[i].url
						}
					}
				})
			},
			//会议详情
			getMeetingDetails(){
				const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						document.title=data.name;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(data.name,data.title,data.shareimg);
						}
					}
				})
			},
            skip(id){
				window.location.href=this.meetingButton[id];
            }
		}
	}
</script>                                                                                                                                 
<style lang="scss" scoped>
	.meeting-details{
        background: white;
		.banner-show{
			width:100%;
			// height:210px;
			padding:0px;
			.cover{
				width:100%;
				// height:210px;
				// margin-bottom:14px;
				img{
					width:100%;
					// height:210px;
				}
			}
		}
		.buttons{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 25px;
            .one{
                width: 32%;
				margin-bottom: 5px;
            }
            .two{
                width:65%;
            }
            img{
                width: 100%;
            }
            .grid{
                width:66%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .half{
                    width: 48.5%;
                }
            }
        }
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/xbh2024/index.vue